import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { ImageUrlService } from '@nx-ng/services/image-url.service';
import { takeUntil, take } from 'rxjs/operators';
import { HttpStatusCode } from '@angular/common/http';
import { FaresActions, FareSelectorActions } from '@modules/ticket-fares-store';
import { isApiError } from '@nx-ng/util';
import { Subject } from 'rxjs';
import { AddressesStoreActions } from '@modules/addresses-store';
import { CustomerStoreActions } from '@modules/customer-store';
import {
  CompleteCheckoutActions,
  DirectDebitActions,
  ImageActions,
  PostcodeChildTicketVerifyActions,
} from '@modules/checkout-store';
import { OrderActions } from '@modules/order-store';
import { CoreFacade } from '@modules/core/core.facade';
@Component({
  selector: 'nx-ng-technical-difficulties',
  templateUrl: './technical-difficulties.component.html',
  styleUrls: ['./technical-difficulties.component.scss'],
})
export class TechnicalDifficultiesComponent implements OnInit, OnDestroy {
  @Output()
  close: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  showError: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  retryTextKey = 'try_again';

  @Input()
  closeTextKey = 'close';

  @Input()
  set showInitial(value: boolean) {
    this.show = value;
    if (value) {
      this.canRetry = false;
      this.subText = 'technical_difficulties_bad_request';
    }
  }

  canRetry = false;
  show = false;

  subText = 'technical_difficulties_subtext';

  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public imageUrlService: ImageUrlService,
    private actions$: Actions,
    public coreFacade: CoreFacade
  ) {}

  ngOnInit(): void {
    this.actions$
      .pipe(
        ofType(
          AddressesStoreActions.addressAPI_drillDownFailure,
          AddressesStoreActions.addressAPI_retrieveFailure,
          AddressesStoreActions.addressAPI_searchFailure,
          CustomerStoreActions.loadDataAccessCustomerDetailsFailure,
          CustomerStoreActions.customerAPI_verifyMobileAppFailure,
          CustomerStoreActions.customerAPI_verifySwiftCardFailure,
          CustomerStoreActions.customerAPI_GetApplicantSwiftCardsFailure,
          CustomerStoreActions.customerAPI_loadBillingCustomerApplicantsFailure,
          CustomerStoreActions.customerAPI_CreateCustomerFailure,
          CustomerStoreActions.customerAPI_UpdateCustomerFailure,
          CompleteCheckoutActions.checkoutAPI_checkoutBasketFailure,
          DirectDebitActions.checkoutAPI_verifyDirectDebitDetailsFailure,
          FaresActions.loadFareByIdFailure,
          FaresActions.loadFlexiFaresFailure,
          FaresActions.loadPaygFaresFailure,
          FaresActions.searchFaresFailure,
          FareSelectorActions.loadTicketSelectorsFailure,
          PostcodeChildTicketVerifyActions.checkoutAPI_verifyPostcodeChildTicketFailure,
          CompleteCheckoutActions.checkoutAPI_checkoutBasketFailure,
          ImageActions.checkoutAPI_loadImageFailure,
          ImageActions.checkoutAPI_uploadImageFailure,
          OrderActions.orderAPI_loadOrderFailure
        ),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(({ error }) => {
        if (
          !isApiError(error) ||
          (isApiError(error) && error.code === HttpStatusCode.BadRequest)
        ) {
          this.canRetry = false;
          this.subText = 'technical_difficulties_bad_request';
        } else {
          this.canRetry = true;
          this.subText = 'technical_difficulties_subtext';
        }
        this.show = true;
        this.showError.emit(true);
      });

    this.actions$
      .pipe(
        ofType(FaresActions.searchFaresSuccess),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((res) => {
        if (res.fareResponse.length === 0) {
          this.show = true;
          this.showError.emit(true);
          this.canRetry = false;
          this.subText = '';
        }
      });

    this.coreFacade.retryActions$.pipe(take(1)).subscribe((retryActions) => {
      if (retryActions.length > 0) {
        this.canRetry = true;
        this.showError.emit(true);
        this.show = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }

  get btnText() {
    return this.canRetry ? this.retryTextKey : 'close';
  }

  handleButtonClick() {
    this.close.emit(this.canRetry);
    this.showError.emit(false);

    this.show = false;
  }
}
